import { WidgetExtended } from '@/types/dashboard'

export function hasConfigChanged (
    originalWidget: WidgetExtended | undefined,
    currentWidget: WidgetExtended | undefined
): boolean {
    if (!originalWidget || !currentWidget) {
        return false
    }

    const originalConfig = originalWidget.WidgetConfig || []
    const currentConfig = currentWidget.WidgetConfig || []

    const originalConfigString = JSON.stringify(originalConfig)
    const currentConfigString = JSON.stringify(currentConfig)

    return !(originalConfigString === currentConfigString)
}


